export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "Northern Cape",
  "North West",
  "Western Cape",
];

export const CITIES_BY_PROVINCE = {
  "Western Cape": [
    "Cape Town",
    "Stellenbosch",
    "George",
    "Paarl",
    "Worcester",
    "Mossel Bay",
    "Hermanus",
    "Knysna",
    "Bellville",
    "Somerset West",
    "Strand",
    "Malmesbury",
    "Swellendam",
    "Oudtshoorn",
    "Saldanha",
    "Vredenburg",
    "Caledon",
    "Robertson",
    "Wellington",
    "Bredasdorp"
  ],
  Gauteng: [
    "Johannesburg",
    "Pretoria",
    "Soweto",
    "Sandton",
    "Midrand",
    "Benoni",
    "Boksburg",
    "Germiston",
    "Kempton Park",
    "Randburg",
    "Roodepoort",
    "Krugersdorp",
    "Alberton",
    "Springs",
    "Centurion",
    "Brakpan",
    "Edenvale",
    "Vereeniging",
    "Vanderbijlpark",
    "Nigel",
    "Tembisa",
    "Katlehong",
    "Alexandra",
    "Diepsloot"
  ],
  "KwaZulu-Natal": [
    "Durban",
    "Pietermaritzburg",
    "Richards Bay",
    "Newcastle",
    "Pinetown",
    "Empangeni",
    "Port Shepstone",
    "Ladysmith",
    "Kokstad",
    "Dundee",
    "Estcourt",
    "Vryheid",
    "Ulundi",
    "Eshowe",
    "Greytown",
    "Margate",
    "Scottburgh",
    "Umhlanga",
    "Ballito",
    "Tongaat"
  ],
  "Eastern Cape": [
    "Gqeberha",
    "Port Elizabeth",
    "East London",
    "Mthatha",
    "Uitenhage",
    "Grahamstown",
    "Makanda",
    "Queenstown",
    "King William's Town",
    "Mdantsane",
    "Butterworth",
    "Bisho",
    "Fort Beaufort",
    "Graaff-Reinet",
    "Port Alfred",
    "Cradock",
    "Somerset East",
    "Alice",
    "Stutterheim",
    "Jeffreys Bay"
  ],
  "Free State": [
    "Bloemfontein",
    "Welkom",
    "Bethlehem",
    "Kroonstad",
    "Sasolburg",
    "Phuthaditjhaba",
    "Virginia",
    "Bothaville",
    "Parys",
    "Odendaalsrus",
    "Harrismith",
    "Vredefort",
    "Ficksburg",
    "Senekal",
    "Heilbron"
  ],
  Limpopo: [
    "Polokwane",
    "Tzaneen",
    "Thohoyandou",
    "Mokopane",
    "Lebowakgomo",
    "Phalaborwa",
    "Musina",
    "Louis Trichardt",
    "Makhado",
    "Giyani",
    "Bela-Bela",
    "Modimolle",
    "Thabazimbi",
    "Lephalale",
    "Hoedspruit"
  ],
  Mpumalanga: [
    "Mbombela",
    "Nelspruit",
    "Witbank",
    "eMalahleni",
    "Secunda",
    "Standerton",
    "Middelburg",
    "Ermelo",
    "Piet Retief",
    "Bethal",
    "Barberton",
    "White River",
    "Sabie",
    "Hazyview",
    "Graskop",
    "Lydenburg",
    "Carolina"
  ],
  "Northern Cape": [
    "Kimberley",
    "Upington",
    "Kuruman",
    "Springbok",
    "De Aar",
    "Postmasburg",
    "Kathu",
    "Calvinia",
    "Carnarvon",
    "Britstown",
    "Prieska",
    "Pofadder"
  ],
  "North West": [
    "Rustenburg",
    "Klerksdorp",
    "Mahikeng",
    "Potchefstroom",
    "Brits",
    "Vryburg",
    "Mmabatho",
    "Lichtenburg",
    "Zeerust",
    "Schweizer-Reneke",
    "Taung",
    "Christiana",
    "Koster"
  ],
};
